import React from 'react'
import { ConfigProvider, Row, Col, Button, Input, Table, Popconfirm } from 'antd'
import zhCN from 'antd/es/locale/zh_CN';
import { PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom'
import './index.css'
import Axios from 'axios';

export default class BaseContent extends React.Component {

    state = {
        selectedRowKeys: [], // 此处可配置默认选中列
        data: [],
        currentPage: 1
    }

    componentDidMount() {
        // Axios.get('http://localhost:8081/article/getArticles/0/10')
        Axios.get('../../data/repository.json')
            .then(res => {
                console.log(res.data)
                this.setState({
                    data: res.data
                })
            })
    }

    onSelectChange = (selectedRowKeys) => {
        console.log('selectedRowKeys changed: ', selectedRowKeys)   // 选择的key值
        this.setState({ selectedRowKeys })
    }

    render() {

        const { selectedRowKeys } = this.state;
        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange
        }

        return (
            <div className={this.props.isMore ? "base-content-hidden" : "base-content-show"}>
                <ConfigProvider locale={zhCN}>
                    <Row>
                        <Col>
                            <Link to='/ManagerCenter/RepositoryNew'>
                                <Button icon={<PlusOutlined />}>新建文章</Button>
                            </Link>
                        </Col>
                        <Col offset={1}>
                            <Button className="batch-operation">批量操作</Button>
                        </Col>
                        <Col offset={2}>
                            <Input placeholder="请输入关键字" />
                        </Col>
                    </Row>
                    <Row className="base-content-list">
                        <Col span={24}>
                            <Table
                                rowSelection={rowSelection}
                                // 左侧的选择框是通过 key 值来判断是选择了哪个
                                dataSource={this.state.data.map((item, index) => {
                                    item.key = `key-${index}`
                                    return item
                                })}
                            >
                                <Table.Column title={"标题"} dataIndex="title" width="250px" align="center" />
                                <Table.Column title={"作者"} dataIndex="author" width="150px" align="center" />
                                <Table.Column title={"分类"} dataIndex="type" width="150px" align="center" />
                                <Table.Column title={"创建时间"} dataIndex="created" width="100px" align="center" />
                                <Table.Column
                                    title={"操作"}
                                    dataIndex='editor-operation'
                                    width="100px"
                                    align="center"
                                    render={(text, record) =>
                                        // <Space size="large" key={`space-${text}`}>
                                        <>
                                            <Popconfirm title="确定进行修改?">
                                                <EditOutlined style={{marginRight:30}}/>
                                            </Popconfirm>
                                            <Popconfirm title="确定进行删除?">
                                                <DeleteOutlined />
                                            </Popconfirm>
                                            {/* </Space> */}
                                        </>
                                    }

                                />

                            </Table>
                        </Col>
                    </Row>
                </ConfigProvider>
            </div>
        )
    }
}